import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialInstitutionItemIdentityByIdRequest,
    type GetTrialInstitutionItemIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useTrialInstitutionItemIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetTrialInstitutionItemIdentityByIdResponse,
        GetTrialInstitutionItemIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetTrialInstitutionItemIdentityByIdResponse> =>
            new GetTrialInstitutionItemIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetTrialInstitutionItemIdentityByIdResponse>) =>
                response?.data?.trialInstitutionItemIdentity,
            getError: (response?: SWRResponse<GetTrialInstitutionItemIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useTrialInstitutionItemIdentityById;
